import React, { useEffect } from "react";
import Banner from "../components/markets/Banner";
import OneAccount from "../components/markets/OneAccount";
import CompareTable from "../components/markets/CompareTable";
import BuiltFor from "../components/markets/BuiltFor";
import FAQ from "../components/markets/FAQ";
import ReadyMoves from "../components/markets/ReadyMoves";
import MarketsCTA from "../components/markets/MarketsCTA";

function Markets() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <OneAccount />
      <CompareTable />
      <BuiltFor />
      <FAQ />
      <ReadyMoves />
      <MarketsCTA />
    </div>
  );
}

export default Markets;
